import type { FaireProductEntity } from "../../entity_types/product";

export const p_m6k5aswxyw: FaireProductEntity = {
  token: "p_m6k5aswxyw",
  type: "product",
  name: "Adjustable Harem Overalls - Prepack of 5 colors - Tie Dye",
  brandToken: "b_vn9q3djcqf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1c780b5222d312f0f49ba3ae7033d6ee438b3d62f35420ecb464f4b1f30c26ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4bed5a0f86290d58581b5e3ae9d9ae2e9f3d31b41a904f5f89f33fa50fe17caa.jpeg",
    "https://cdn.faire.com/fastly/e77e88323ebdf5879d7654aacae242bda5b041c1bcdae6198902ee297226477b.jpeg",
    "https://cdn.faire.com/fastly/9688cceb3f295b0d06322086cb78422d268fd9b8f25bacfbe85d0d91ec3dafc9.jpeg",
    "https://cdn.faire.com/fastly/23ac2ae7a851f2e99e30de4f9c8f4418e1ce84123b539f8e764c77718199365c.jpeg",
    "https://cdn.faire.com/fastly/d199ba0d42805ff43ea96f445e074d616ee58af68a417fc1fa9db7026901f114.jpeg",
    "https://cdn.faire.com/fastly/6732d11145b3ca61dd66831a50e82af56bb554c5d188c5023956a3a4396d22c6.jpeg",
    "https://cdn.faire.com/fastly/3f73c6d97a3f715e3c1205098ced68c40572f6ea1e0a063f8b1e921cf70ff442.jpeg",
    "https://cdn.faire.com/fastly/c4200678977fd8cd60d5f48562e25f51e8b43ef6e50a880997d7e48d062ff4ae.jpeg",
  ],
  priceDollars: 173.21,
  description:
    "The Harem Overall from Katmandu Trading reminds us of what truly matters in fashion – comfort, quality, sustainability, and a connection to our global community. It's a small piece of the world, but in its smallness lies its significance. It's a testament to the things that matter – the artisan's skill, the material's quality, the culture's story, and the trade's ethics.\n\nWear it, and it becomes more than an overall – it's a narrative, a piece of art, a slice of tradition. In a world where much is transient, this overall offers a connection to something lasting, to the artisans of Nepal, to the traditions of craftsmanship, to the principles of fair trade. It's not just clothing; it's a lifestyle choice, a story told, a truth lived.\n\nBrand: Katmandu Trading Company\nCountry Of Origin: Handmade in Nepal\nAvailability: Limited\nSizing: Free size/Fits up to 42\" waist,  Length - 62\" Width - 50\" Depth - 0.1\"\nMaterial: Handwoven organic Shyama cotton\nSpecial Features: Secret pocket, Katma",
  tags: [],
  msrpDollars: 346.42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:02.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
